"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography, TextButton, Icon } from "@/shared/ui/atoms";
import { useRef, useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { formatDate } from "@/shared/utils/format";
import { maskAuthor } from "@/shared/utils/format";
import { renderContentWithMatchHighlights } from "@/widgets/review-detail/model/highlightMatchContents";
import { formatFivePointRating } from "@/entities/hospital/lib/rating";
interface DetailReviewProps {
  score: string | number;
  author: string;
  createAt: string;
  content: string;
  matchContents?: string[];
  /** 상세필터(major·minor)가 URL에 모두 있을 때만 matchContents 하이라이트 */
  applyMatchHighlight: boolean;
}
const DetailReview = t0 => {
  const $ = _c(43);
  const {
    score,
    author,
    createAt,
    content,
    matchContents,
    applyMatchHighlight
  } = t0;
  const t = useTranslations();
  const [isMore, setIsMore] = useState(false);
  const [isShowMoreButton, setIsShowMoreButton] = useState(false);
  const textRef = useRef(null);
  let t1;
  if ($[0] !== createAt) {
    t1 = formatDate(createAt);
    $[0] = createAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedDate = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!textRef.current) {
        return;
      }
      if (textRef.current.scrollHeight > textRef.current.clientHeight) {
        setIsShowMoreButton(true);
      } else {
        setIsShowMoreButton(false);
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const checkShowMoreButton = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const timer = setTimeout(() => {
        checkShowMoreButton();
      }, 0);
      window.addEventListener("resize", checkShowMoreButton);
      return () => {
        clearTimeout(timer);
        window.removeEventListener("resize", checkShowMoreButton);
      };
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== applyMatchHighlight || $[5] !== content || $[6] !== matchContents) {
    t4 = [content, matchContents, applyMatchHighlight];
    $[4] = applyMatchHighlight;
    $[5] = content;
    $[6] = matchContents;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon src="/icons/star.svg" width={20} height={20} alt="star" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = Number(score);
  let t7;
  if ($[9] !== t6) {
    t7 = formatFivePointRating(t6);
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <Typography className="ml-[2px] text-[#333438 font-bold">{t7}</Typography>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="mx-[6px] w-[3px] h-[3px] bg-gray-300 rounded-full" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== author) {
    t10 = maskAuthor(author);
    $[14] = author;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <Typography size={12} lineHeight="normal" className="text-[#C2C4C8]"><span suppressHydrationWarning={true}>{t10}</span></Typography>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t8) {
    t12 = <div className="flex items-center">{t5}{t8}{t9}{t11}</div>;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== formattedDate) {
    t13 = <Typography size={12} lineHeight="normal" className="text-[#C2C4C8]">{formattedDate}</Typography>;
    $[21] = formattedDate;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12 || $[24] !== t13) {
    t14 = <div className="flex items-start justify-between gap-2">{t12}{t13}</div>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = `text-overflow-ellipsis ${isMore ? "line-clamp-none" : "line-clamp-3"}`;
  let t16;
  if ($[26] !== applyMatchHighlight || $[27] !== content || $[28] !== matchContents) {
    t16 = applyMatchHighlight ? renderContentWithMatchHighlights(content, matchContents) : content;
    $[26] = applyMatchHighlight;
    $[27] = content;
    $[28] = matchContents;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t15 || $[31] !== t16) {
    t17 = <div className="relative"><Typography ref={textRef} size={15} className={t15}>{t16}</Typography></div>;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== isMore || $[34] !== isShowMoreButton || $[35] !== t) {
    t18 = !isMore && isShowMoreButton && <TextButton text={t("commonReview.more")} onClick={() => {
      setIsMore(!isMore);
    }} size={14} className="absolute right-0 top-1/2 -translate-y-1/2 text-[#5A5C63] leading-[21px] underline decoration-solid" />;
    $[33] = isMore;
    $[34] = isShowMoreButton;
    $[35] = t;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t18) {
    t19 = <div className="relative">{t18}</div>;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t14 || $[40] !== t17 || $[41] !== t19) {
    t20 = <div className="py-5 px-4 flex flex-col gap-[10px] border-b border-[#F4F4F5]">{t14}{t17}{t19}</div>;
    $[39] = t14;
    $[40] = t17;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
};
export default DetailReview;